// @flow

import styled, { css } from "styled-components";
import {
  fontNormal,
  fontMedium,
  fontCondensedNormal,
  fontBold,
  defaultSize
} from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";
import { buildText } from "../../_atom/Text";

export const PPCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  outline: none;
  ${(props) =>
    props.isSelected
      ? css`
          background-color: ${buildColor("blue", "000")};
          position: relative;

          &::before {
            content: "";
            position: absolute;
            width: 2px;
            top: 0;
            left: 0;
            bottom: 0;
            background-color: ${buildColor("blue_accent", "500")};
          }
        `
      : css`
          background-color: ${buildColor("white", "0")};
        `};

  @media (pointer: fine) {
    &:hover {
      cursor: pointer;
      background-color: ${buildColor("blue", "100")};
    }
  }

  @media (pointer: coarse) {
    &:active {
      background-color: ${buildColor("blue", "100")};
    }
  }
`;

export const RaceInfo = styled.div`
  width: 100%;
  flex: 1 1 auto;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  max-width: 100%;
  font-family: ${fontBold};
  font-style: normal;
  font-weight: bold;
  line-height: 22px;
`;

export const Title = styled.span`
  font-family: ${fontBold};
  font-size: 14px;
  color: ${buildColor("grey", "900")};
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TitleComplement = styled.span`
  font-family: ${fontBold};
  font-size: 14px;
  color: ${buildColor("grey", "900")};
  display: inline-block;
  flex-shrink: 0;
`;

export const Date = styled(
  buildText({
    tag: "span",
    fontSize: 14,
    color: buildColor("grey", "600")
  })
)`
  margin-right: 4px;
  font-family: ${fontNormal};
  font-style: normal;
  line-height: 18px;
`;

export const IconWrapper = styled.span`
  margin-left: 4px;
`;

export const RaceDataList = styled.ul`
  margin-top: 4px;
  list-style: none;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
`;

export const RaceDataListItem = styled.li`
  font-family: ${({ isHighlighted }) =>
    isHighlighted ? fontMedium : fontNormal};
  font-size: ${defaultSize};
  line-height: 18px;
  color: ${buildColor("grey", "800")};
  display: flex;
  align-items: center;
  margin-right: 6px;
`;

export const RaceReport = styled.p`
  margin-top: 4px;
  font-family: ${fontNormal};
  font-size: ${defaultSize};
  line-height: 18px;
  color: ${buildColor("grey", "800")};
  text-align: left;
`;

export const PPCardHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const PPCardOptions = styled.div`
  display: flex;
  align-self: center;
`;

export const FavoriteTag = styled.span`
  margin-left: 6px;
  padding: 1px 6px;
  color: ${buildColor("yellow", "900")};
  background: ${buildColor("yellow", "100")};
  border-radius: 12px;
  font-family: ${fontCondensedNormal};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  vertical-align: text-top;
`;

export const Separator = styled.span`
  color: ${buildColor("grey", "600")};
  margin-left: 6px;
`;
